import React from 'react'
import DummyMenu from '../../components/DummyMenu'

const DummyMenuView = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Dummy Menu</h1>
        <p className="page-subtitle">Transaction menu system with sample data</p>
      </div>
      <DummyMenu />
    </div>
  )
}

export default DummyMenuView